import { makeAutoObservable } from "mobx";
import dataRequest from "../http/DataRequest";
import { getRestaurantGroupFromRow, safeNum } from "../utils/iikoOlapGroup";

function parseGroupRows(rows) {
  if (!Array.isArray(rows)) return [];
  const items = rows
    .map((row) => {
      const group = getRestaurantGroupFromRow(row);
      if (!group) return null;
      const revenue = safeNum(row.DishDiscountSumInt);
      const guests = safeNum(row.GuestNum);
      const orders = safeNum(row.UniqOrderId);
      const avgCheck = safeNum(row["DishDiscountSumInt.average"]);
      return { group, revenue, guests, orders, avgCheck };
    })
    .filter(Boolean);
  items.sort((a, b) => b.revenue - a.revenue);
  const totalRevenue = items.reduce((s, x) => s + x.revenue, 0);
  return items.map((x) => ({
    ...x,
    sharePct: totalRevenue > 0 ? (x.revenue / totalRevenue) * 100 : 0,
  }));
}

class GroupsStore {
  groups = [];
  isLoading = false;
  errorMessage = null;

  constructor() {
    makeAutoObservable(this);
  }

  get totalRevenue() {
    return this.groups.reduce((s, g) => s + g.revenue, 0);
  }

  async fetchGroups(serverId, dateFrom, dateTo) {
    if (serverId === "" || serverId == null) return;
    this.isLoading = true;
    this.errorMessage = null;
    try {
      const resp = await dataRequest.getIikoOlapData(serverId, dateFrom, dateTo, true, null);
      this.groups = parseGroupRows(resp?.data || []);
    } catch (e) {
      this.errorMessage = e?.response?.data?.message || e?.message || "Ошибка загрузки";
      this.groups = [];
    } finally {
      this.isLoading = false;
    }
  }
}

const groupsStore = new GroupsStore();
export default groupsStore;
